// src/components/DeepLinkRedirect.js
import { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';

const DeepLinkRedirect = () => {
  const location = useLocation();
  const { '*': path } = useParams();
  
  useEffect(() => {
    // Get full path from location
    let fullPath = location.pathname;
    if (fullPath.startsWith('/')) {
      fullPath = fullPath.substring(1);
    }
    
    const query = location.search;
    const fullPathWithQuery = query ? `${fullPath}${query}` : fullPath;
    
    const userAgent = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/.test(userAgent);
    const isAndroid = /Android/.test(userAgent);
    
    if (isIOS) {
      window.location.href = `hazirlan://${fullPathWithQuery}`;
      setTimeout(() => {
        window.location.href = 'https://apps.apple.com/app/hazirlan/id6749094669';
      }, 2500);
    } else if (isAndroid) {
      window.location.href = `intent://${fullPathWithQuery}#Intent;scheme=hazirlan;package=com.mmucteba.hazirlan;end`;
      setTimeout(() => {
        window.location.href = 'https://play.google.com/store/apps/details?id=com.mmucteba.hazirlan';
      }, 2500);
    }
  }, [location, path]);
  
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '100vh',
      padding: '20px',
      textAlign: 'center',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <h1 style={{ fontSize: '24px', marginBottom: '16px' }}>Opening Hazirlan App...</h1>
      <p style={{ fontSize: '16px', color: '#666', marginBottom: '24px' }}>
        If the app doesn't open automatically, please download it:
      </p>
      <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
        <a 
          href="https://apps.apple.com/app/hazirlan/id6749094669"
          style={{ 
            padding: '12px 24px',
            backgroundColor: '#007AFF',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '8px',
            fontWeight: '600'
          }}
        >
          Download for iOS
        </a>
        <a 
          href="https://play.google.com/store/apps/details?id=com.mmucteba.hazirlan"
          style={{ 
            padding: '12px 24px',
            backgroundColor: '#34A853',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '8px',
            fontWeight: '600'
          }}
        >
          Download for Android
        </a>
      </div>
    </div>
  );
};

export default DeepLinkRedirect;

